module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/bold_0-4d9e1a1a342e919a6dd8251281c84c4f.png";